import { SearchCriteria } from "../../common/models/search-criteria";
import { CategoriaFaccetta } from "./categoria-faccetta";

export class FaccettaRequest {

    searchRequest: SearchCriteria;
    faccetteApplicabili: CategoriaFaccetta[];
    includePratiche:boolean;
}